import { render, staticRenderFns } from "./PartidaPage.vue?vue&type=template&id=6186cbbe"
import script from "./PartidaPage.js?vue&type=script&lang=js&external"
export * from "./PartidaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports